import { baseApi } from "./base.api";

export const usersApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    fetchUsers: build.query({
      query: (params) => ({ url: "/users/fetch", method: "GET", params }),
      providesTags: ["User"],
    }),
    fetchTrashedUsers: build.query({
      query: (params) => ({ url: "/users/fetch/trashed", method: "GET", params }),
      providesTags: ["User"],
    }),
    fetchMonitoringOfficers: build.query({
      query: (params) => ({ url: "/users/monitoring-officers", method: "GET", params }),
      providesTags: ["User"],
    }),
    fetchAllDoctors: build.query({
      query: (params) => ({ url: "/users/all-doctors", method: "GET", params }),
      providesTags: ["User"],
    }),
    fetchUserById: build.query({
      query: (id) => ({ url: `/users/fetch/${id}`, method: "GET" }),
      providesTags: ["User"],
    }),
    createUser: build.mutation({
      query: (body) => ({ url: "/users/create", method: "POST", body }),
      invalidatesTags: ["User"],
    }),
    updateUser: build.mutation({
      query: ({ id, body }) => ({ url: `/users/update/${id}`, method: "PUT", body }),
      invalidatesTags: ["User"],
    }),
    updateUserProfile: build.mutation({
      query: ({ id, body }) => ({ url: `/users/profile/update/${id}`, method: "PUT", body }),
      invalidatesTags: ["User"],
    }),
    updateUserPassword: build.mutation({
      query: ({ id, body }) => ({ url: `/users/password/update/${id}`, method: "PUT", body }),
      invalidatesTags: ["User"],
    }),
    restoreUser: build.mutation({
      query: (id) => ({ url: `/users/restore/${id}`, method: "PUT" }),
      invalidatesTags: ["User"],
    }),
    bulkRestoreUsers: build.mutation({
      query: (body) => ({ url: "/users/bulk-restore", method: "POST", body }),
      invalidatesTags: ["User"],
    }),
    deleteUser: build.mutation({
      query: (id) => ({ url: `/users/delete/${id}`, method: "DELETE" }),
      invalidatesTags: ["User"],
    }),
    bulkDeleteUsers: build.mutation({
      query: (body) => ({ url: "/users/bulk-delete", method: "POST", body }),
      invalidatesTags: ["User"],
    }),
    destroyUser: build.mutation({
      query: (id) => ({ url: `/users/destroy/${id}`, method: "DELETE" }),
      invalidatesTags: ["User"],
    }),
    bulkDestroyUsers: build.mutation({
      query: (body) => ({ url: "/users/bulk-destroy", method: "POST", body }),
      invalidatesTags: ["User"],
    }),
  }),
});

export const {
  useFetchUsersQuery,
  useFetchTrashedUsersQuery,
  useFetchMonitoringOfficersQuery,
  useFetchUserByIdQuery,
  useCreateUserMutation,
  useUpdateUserMutation,
  useUpdateUserProfileMutation,
  useUpdateUserPasswordMutation,
  useRestoreUserMutation,
  useBulkRestoreUsersMutation,
  useDeleteUserMutation,
  useBulkDeleteUsersMutation,
  useDestroyUserMutation,
  useFetchAllDoctorsQuery,
  useBulkDestroyUsersMutation,
} = usersApi;
